import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import { useSEO } from '../hooks/useSEO';
import Logo from '../components/Logo';
import './NotFound.css';

/**
 * A mistyped address used to land on the site's chrome with nothing under it —
 * a header, a footer, and a blank page in between, which reads as the site
 * being broken rather than as the address being wrong. This says which of the
 * two happened and offers the two pages most people were heading for anyway.
 *
 * `noIndex` matters: without it a search engine that follows a stale link
 * indexes this page under whatever URL produced it.
 */
export default function NotFound() {
  const { t } = useLang();
  useSEO(t('nf_title'), t('nf_text'), undefined, true);

  return (
    <div className="nf-page">
      <div className="container nf-inner">
        <Logo size={64} tone="light" />
        <p className="nf-code">404</p>
        <h1>{t('nf_title')}</h1>
        <p className="nf-text">{t('nf_text')}</p>
        <div className="nf-actions">
          <Link to="/" className="btn-primary">{t('nf_home')}</Link>
          <Link to="/courses" className="btn-outline-navy">{t('nf_courses')}</Link>
        </div>
      </div>
    </div>
  );
}
